/*Halado_5_1 3:21 */
import React from 'react'

export default function AboutPage() {
  return (
    <div className='about-container'>
      <div className='about-text'>
      
      <h1>Bemutatkozás</h1>

      <p>MSc Gépészmérnökként végeztem, diplomamunkámban daruszerű szerkezet végeselemes földrengésre ellenőrzését, méretezését és optimálását végeztem el.</p>

      <p>Koronavírus okozta karantén idején kezdtem el foglalkozni az áramlások numerikus szimulációjával (angol nevén CFD - Computational Fluid Dynamics)</p>

      <p>Később a Debreceni Egyetemen Gépészeti Szimulációs Szakmérnöki oklevelet szereztem hő és áramlástani (CFD) és a mechanikai (FEA) szimulációk területén. Szakdolgozat témám a nukleáris iparhoz köthető hő és áramlástani probléma szimulációja volt.</p>

      <p>2023-ban egy generálkivitelező cég fenntarthatósági csapatába vettek fel, ahol az épületek energiahatékonyságának javításában működtem közre. 
        Munkám részeként természetes szellőzéshez, épületgépészethez, épületfizikához, épületkomforthoz kapcsolódó hő és áramlástani szimulációkat végeztem. 
        Olyan projecteken dolgoztam, mint például a Mikolc Koronaszálló felújítása és az erlangeni tűzoltóállomás bővítése.</p>

      <p>
        Később az EQUINOX Consultancy csapata részeként a korábbi munkáim irányzatát folytattam, aminek részeként például CFD szimulációkkal támogattam várostervezést, gyalogos komfortot is vizsgáltam.
      </p>

      <p>Megkezdett szakmai irányvonalamat egyéni vállalkozóként folytatom...</p>


      </div>
    </div>
  )
}
